import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { styles } from '../../styles/chart-panel-styles';
import Grid from '@material-ui/core/Grid';
import Fade from '@material-ui/core/Fade';
import * as utils from './utils';

const GridPanel = (props) => {
    const { classes } = props;
    return (
    <div className={classes.root}>
      <Fade in={true} timeout={1500}>
        <Grid container spacing={16} alignItems="stretch" alignContent="stretch">
          {props.cards}
        </Grid>
      </Fade>
    </div>);
  }

  GridPanel.propTypes = {
    classes: PropTypes.object.isRequired,
  };
  
  export default withStyles(styles)(GridPanel);



// WEBPACK FOOTER //
// ./src/components/ChartPanel/GridPanel.js